/**
 * section-faq-tabs-nav.js
 * Handles tab pill click → smooth scroll to target FAQ section.
 * Uses IntersectionObserver to update active tab on scroll.
 * Place in: assets/section-faq-tabs-nav.js
 */
(function () {
  'use strict';

  function initTabsNav(nav) {
    var tabs = Array.from(nav.querySelectorAll('[data-tab-target]'));
    if (!tabs.length) return;

    /* ---- Click: scroll + set active ---- */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var targetEl = document.getElementById(this.getAttribute('data-tab-target'));
        if (!targetEl) return;
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActive(this.getAttribute('data-tab-target'));
      });
    });

    function setActive(targetId) {
      tabs.forEach(function (t) {
        t.classList.toggle('faq-tabs-nav__tab--active', t.getAttribute('data-tab-target') === targetId);
      });
    }

    /* ---- Scroll: IntersectionObserver updates active tab ---- */
    if (!('IntersectionObserver' in window)) return;

    var targets = tabs.map(function (t) {
      return document.getElementById(t.getAttribute('data-tab-target'));
    }).filter(Boolean);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, {
      rootMargin: '-15% 0px -70% 0px',
      threshold: 0
    });

    targets.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    document.querySelectorAll('.faq-tabs-nav').forEach(initTabsNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var nav = e.target.querySelector('.faq-tabs-nav');
    if (nav) initTabsNav(nav);
  });
})();
